import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FiStar } from 'react-icons/fi';
import './ProductCard.css';

const ProductCard = ({ product }) => {
    const navigate = useNavigate();

    const handleCardClick = () => {
        navigate(`/product/${product.id}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <motion.div
            variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 1, y: 0, transition: { duration: 1, ease: [0.16, 1, 0.3, 1] } }
            }}
            whileHover={{ y: -8 }}
            className="premium-poster-card"
            onClick={handleCardClick}
            layout
        >
            <div className="poster-frame">
                <motion.img
                    src={product.image}
                    alt={product.name}
                    initial={{ filter: "blur(10px)", scale: 1.1 }}
                    animate={{ filter: "blur(0px)", scale: 1 }}
                    transition={{ duration: 1.5, ease: "easeOut" }}
                />
                <motion.div
                    className="card-overlay"
                    initial={{ opacity: 0, y: 20 }}
                    whileHover={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, ease: "easeOut" }}
                >
                    <span className="explore-text">View Product</span>
                    <div className="explore-line" />
                </motion.div>
                {product.inStock === false && (
                    <div style={{
                        position: 'absolute',
                        top: '15px',
                        right: '15px',
                        background: 'rgba(231, 76, 60, 0.9)',
                        color: 'white',
                        padding: '5px 12px',
                        borderRadius: '20px',
                        fontFamily: 'var(--font-nav)',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        letterSpacing: '1px',
                        zIndex: 10,
                        textTransform: 'uppercase',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.3)'
                    }}>
                        Out of Stock
                    </div>
                )}
            </div>
            <div className="poster-details">
                <div className="poster-meta">
                    <span className="poster-category">{product.category}</span>
                    <div className="rating-stars">
                        {[...Array(5)].map((_, i) => (
                            <FiStar key={i} size={8} fill="var(--accent-primary)" stroke="none" />
                        ))}
                    </div>
                </div>
                <h3>{product.name}</h3>
                <div className="poster-footer">
                    <p className="price-tag">
                        <b>{product.sizes && product.sizes.length > 0 ? product.sizes[0].price : product.price}</b> LE
                    </p>
                    <span className="quality-tag">Premium Canvas</span>
                </div>
            </div>
        </motion.div>
    );
};

export default ProductCard;
